import { useQuery } from "@tanstack/react-query";
import { queryClient } from "../../../shared/api/queryClient";
import useActionAllowedInArea from "../../auth/hooks/useActionAllowedInArea";
import { getBrandsList } from "../api/getBrandsList";

export const useBrandsListQuery = () => {
  const readAccess = useActionAllowedInArea("brandsAndPages", "read");
  return useQuery({
    queryKey: ["brands"],
    queryFn: getBrandsList,
    enabled: Boolean(readAccess.allowed),
  });
};

export const invalidateBrandsListQuery = () => {
  return queryClient.invalidateQueries({
    queryKey: ["brands"],
  });
};
